import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const aedPurchaseLocaleModule: LocaleModule = {
  name: "aedPurchase",
  messages: { en: en, it: it },
};
